export default __webpack_public_path__ + "static/media/esports-m.e045bded.webp";